import request from '@/utils/request'

// 查询客户已划拨 eSIM 清单
export function findEsims(params) {
  return request({
    url: `/customer/esims`,
    method: 'get',
    params
  })
}

// eSIM 详情
export function findEsimDetail(id) {
  return request({
    url: `/customer/esims/${id}`,
    method: 'get'
  })
}

// Profile 关联列表
export function findEsimProfileLinks(id, params) {
  return request({
    url: `/customer/esims/${id}/profile_links`,
    method: 'get',
    params
  })
}

// 操作记录
export function findEsimEimOperationTasks(id, params) {
  return request({
    url: `/customer/esims/${id}/eim_operation_tasks`,
    method: 'get',
    params
  })
}

export function findEsimEimOperationTask(id, taskId) {
  return request({
    url: `/customer/esims/${id}/eim_operation_tasks/${taskId}`,
    method: 'get'
  })
}

export function abortEsimEimOperationTask(id, taskId) {
  return request({
    url: `/customer/esims/${id}/eim_operation_tasks/${taskId}/abort`,
    method: 'post'
  })
}

// 下载 Profile
export function downloadEsimProfile(id, data) {
  return request({
    url: `/customer/esims/${id}/download_profile`,
    method: 'post',
    data
  })
}

export function enableEsimProfile(id, data) {
  return request({
    url: `/customer/esims/${id}/enable_profile`,
    method: 'post',
    data
  })
}

export function disableEsimProfile(id, data) {
  return request({
    url: `/customer/esims/${id}/disable_profile`,
    method: 'post',
    data
  })
}

export function deleteEsimProfile(id, data) {
  return request({
    url: `/customer/esims/${id}/delete_profile`,
    method: 'post',
    data
  })
}

export function setEsimFallbackProfile(id, data) {
  return request({
    url: `/customer/esims/${id}/set_fallback_profile`,
    method: 'post',
    data
  })
}

export function unsetEsimFallbackProfile(id) {
  return request({
    url: `/customer/esims/${id}/unset_fallback_profile`,
    method: 'post',
    data: {}
  })
}

export function updateEsimEimData(id) {
  return request({
    url: `/customer/esims/${id}/eim_data`,
    method: 'post'
  })
}
